import React from 'react';

/**
 * Previously ensured fixed wallet assets were present in the Builder page's localStorage.
 * The Builder page was archived in March 2026 — this component is now a no-op.
 */
const EnsureFixedAssets: React.FC = () => null;

export default EnsureFixedAssets;
